// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const DayTasksCopilotSidecarContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-daytaskscopilotsidecarcontainer" */ "./DayTasksCopilotSidecarContainer")).then((page)=>{
        return {
            default: page.DayTasksCopilotSidecarContainer
        };
    });
export const LazyDayTasksCopilotSidecarContainer = /*#__PURE__*/ lazy(DayTasksCopilotSidecarContainerLazyLoader);
